import { Link } from 'react-router-dom';

export function Datenschutz() {
  return (
    <div className="mt-[70px]">
      <section className="relative pt-16 pb-10 text-center border-b border-white/[0.06] overflow-hidden">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] rounded-full bg-gold/[0.04] blur-3xl pointer-events-none" />
        <div className="relative z-10 max-w-2xl mx-auto px-6">
          <h1 className="font-display text-4xl md:text-5xl font-bold italic text-glow mb-3">
            Daten<span className="text-gold">schutz</span>
          </h1>
          <p className="text-text-muted">Informationen zur Verarbeitung personenbezogener Daten nach der DSGVO</p>
        </div>
      </section>

      <div className="max-w-[800px] mx-auto px-6 py-12 space-y-6">
        {sections.map((section, i) => (
          <div key={i} className="bg-surface rounded-2xl border border-white/[0.06] p-6 hover:border-gold/25 transition-all">
            <h2 className="flex items-center gap-3 text-base font-bold text-gold mb-4">
              <span className="w-1 h-5 bg-gold rounded-full" />
              {section.title}
            </h2>
            <div className="text-text-secondary text-sm leading-relaxed space-y-3">
              {section.content}
            </div>
          </div>
        ))}

        <Link to="/" className="inline-flex items-center gap-2 mt-4 text-text-muted hover:text-gold transition-colors text-sm font-medium">
          ← Zurück zur Startseite
        </Link>
      </div>
    </div>
  );
}

const sections = [
  {
    title: '1. Verantwortlicher',
    content: (
      <>
        <p>Verantwortlich für die Datenverarbeitung auf dieser Website im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:</p>
        <ul className="space-y-1 mt-2">
          <li><strong className="text-text-primary">Joachim Leiskau</strong></li>
          <li>Alkesis-Kivi-Str. 2</li>
          <li>18016 Rostock</li>
          <li>Deutschland</li>
          <li>E-Mail: <a href="mailto:JL-Software@gmx.de" className="text-gold hover:underline">JL-Software@gmx.de</a></li>
        </ul>
        <p className="mt-2">Es besteht keine Pflicht zur Bestellung eines Datenschutzbeauftragten, da weder ein öffentliches Interesse noch systematische Großverarbeitung vorliegen (Art. 37 DSGVO).</p>
      </>
    ),
  },
  {
    title: '2. Hosting und Server-Logfiles',
    content: (
      <>
        <p>Beim Aufruf dieser Website werden durch den Webserver automatisch technisch notwendige Informationen in sogenannten Server-Logfiles gespeichert:</p>
        <ul className="space-y-1 mt-2">
          <li>• IP-Adresse des anfragenden Geräts</li>
          <li>• Datum und Uhrzeit des Zugriffs</li>
          <li>• Angeforderte URL / Dateiname</li>
          <li>• HTTP-Statuscode und übertragene Datenmenge</li>
          <li>• Referrer-URL (die zuvor besuchte Seite)</li>
          <li>• Browser-Typ und Betriebssystem (User-Agent)</li>
        </ul>
        <p className="mt-2"><strong className="text-text-primary">Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der Darstellung und Sicherheit der Website).<br /><strong className="text-text-primary">Speicherdauer:</strong> Die Logfiles werden nach 7 Tagen automatisch gelöscht.</p>
      </>
    ),
  },
  {
    title: '3. Google Fonts',
    content: (
      <>
        <p>Diese Website nutzt Schriftarten ("Google Fonts") des Anbieters Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland. Beim Laden der Seite baut dein Browser eine direkte Verbindung zu den Servern von Google auf, um die Schriftarten herunterzuladen. Hierbei kann Google deine IP-Adresse erfassen und auswerten.</p>
        <p className="mt-2"><strong className="text-text-primary">Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einheitlicher, browserübergreifender Darstellung).<br />Weitere Informationen: <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-gold hover:underline">Google Datenschutzerklärung</a></p>
      </>
    ),
  },
  {
    title: '4. Kontaktaufnahme per E-Mail',
    content: (
      <>
        <p>Wenn du uns per E-Mail kontaktierst, werden die von dir übermittelten Daten (Absenderadresse, Inhalt, Anhänge, Zeitstempel) ausschließlich zum Zweck der Bearbeitung deines Anliegens gespeichert.</p>
        <p className="mt-2"><strong className="text-text-primary">Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der Beantwortung von Anfragen).<br /><strong className="text-text-primary">Speicherdauer:</strong> Die Daten werden gelöscht, sobald die Anfrage abschließend bearbeitet ist (in der Regel nach 6 Monaten).</p>
      </>
    ),
  },
  {
    title: '5. Cookies und LocalStorage',
    content: (
      <>
        <p>Diese Website verwendet keine Tracking-Cookies und keine Analyse-Tools (z. B. Google Analytics). Es werden keine Werbeprofile erstellt.</p>
        <p className="mt-2">Der Warenkorb speichert Daten ausschließlich im LocalStorage deines Browsers. Diese Daten verlassen dein Gerät nicht und werden nicht an uns oder Dritte übermittelt.</p>
      </>
    ),
  },
  {
    title: '6. Weitergabe von Daten',
    content: (
      <>
        <p>Eine Übermittlung deiner personenbezogenen Daten an Dritte erfolgt nur, wenn:</p>
        <ul className="space-y-1 mt-2">
          <li>• du ausdrücklich eingewilligt hast (Art. 6 Abs. 1 lit. a DSGVO),</li>
          <li>• dies zur Erfüllung eines Vertrags erforderlich ist (Art. 6 Abs. 1 lit. b DSGVO),</li>
          <li>• eine gesetzliche Verpflichtung besteht (Art. 6 Abs. 1 lit. c DSGVO), oder</li>
          <li>• berechtigte Interessen vorliegen (Art. 6 Abs. 1 lit. f DSGVO).</li>
        </ul>
      </>
    ),
  },
  {
    title: '7. Betroffenenrechte',
    content: (
      <>
        <p>Du hast jederzeit das Recht auf:</p>
        <ul className="space-y-1 mt-2">
          <li>• <strong className="text-text-primary">Auskunft</strong> über die bei uns gespeicherten personenbezogenen Daten (Art. 15 DSGVO)</li>
          <li>• <strong className="text-text-primary">Berichtigung</strong> unrichtiger Daten (Art. 16 DSGVO)</li>
          <li>• <strong className="text-text-primary">Löschung</strong> deiner Daten (Art. 17 DSGVO)</li>
          <li>• <strong className="text-text-primary">Einschränkung</strong> der Verarbeitung (Art. 18 DSGVO)</li>
          <li>• <strong className="text-text-primary">Widerspruch</strong> gegen die Verarbeitung (Art. 21 DSGVO)</li>
          <li>• <strong className="text-text-primary">Datenübertragbarkeit</strong> (Art. 20 DSGVO)</li>
        </ul>
        <p className="mt-2">Zur Ausübung deiner Rechte genügt eine formlose E-Mail an <a href="mailto:JL-Software@gmx.de" className="text-gold hover:underline">JL-Software@gmx.de</a>.</p>
      </>
    ),
  },
  {
    title: '8. Datensicherheit',
    content: (
      <p>Wir setzen technische und organisatorische Sicherheitsmaßnahmen ein, um deine Daten gegen Manipulation, Verlust, Zerstörung oder unbefugten Zugriff zu schützen. Diese Maßnahmen werden entsprechend der technologischen Entwicklung fortlaufend verbessert.</p>
    ),
  },
  {
    title: '9. Aktualität und Änderungen',
    content: (
      <p>Diese Datenschutzerklärung hat den Stand: <strong className="text-text-primary">April 2026</strong>. Wir behalten uns vor, diese Erklärung bei Änderungen der rechtlichen Rahmenbedingungen oder der Website-Funktionalitäten anzupassen.</p>
    ),
  },
];
